import { PaginationRequestType } from '@/entity/common/pagination.types';
import Api from '@/repository/api';
import { Accounts, DataEntity } from '@/entity/clients/Accounts/allclients.types';
import { IClientsAccountsAllRepository } from './ClientsAccountsAll.types';
import qs from 'qs';

export class ClientsAccountsAllRepository implements IClientsAccountsAllRepository {
    async fetchAll(data?: FormData): Promise<Accounts> {
        const response = await Api.get('/clients/account/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        return response.data as Accounts;
    }
    async fetchData(data: PaginationRequestType): Promise<DataEntity> {
        const response = await Api.get(`/clients/account/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        return response.data as DataEntity;
    }
}
